import { useMutation, useQueryClient } from '@tanstack/react-query';
import inspectionApi from '../services/inspection.api';
import { inspectionKeys } from './useVehicleInspections';

const useCreateVehicleInspection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: inspectionApi.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: inspectionKeys.all });
    },
  });
};

export default useCreateVehicleInspection;
